import React from "react";
import styles from "./Footer.module.css";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/logo1.png";
import socials from "../../data/socials";

const EXPLORE = [
  { label: "Home", section: "home" },
  { label: "About", section: "about" },
  { label: "Impact", section: "impact" },
  { label: "Why Puducherry", section: "why-puducherry" },
  { label: "Vision & Mission", section: "vision-mission" },
];

/* Events and News are parked alongside their landing sections in App.js and
   their header items in Topbar.js. Restore all of them together. */
const LATEST = [
  // { label: "Events", route: "/all-events" },
  // { label: "News", route: "/all-news" },
  { label: "Gallery", route: "/all-album" },
];

export default function Footer() {
  const navigate = useNavigate();

  const handleActive = (section) => {
    //  If user is not on homepage, go to homepage before scrolling
    navigate(`/#${section}`);
    if (window.location.pathname !== "/") {
      setTimeout(() => {
        const element = document.getElementById(section);
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      const element = document.getElementById(section);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const toTop = () =>
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth",
    });

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* ---- Brand ---- */}
        <div className={styles.brand}>
          <div className={styles.brandHead}>
            <img src={Logo} alt="" className={styles.brandLogo} />
            <div>
              <h2 className={styles.brandName}>Jose Charles Martin</h2>
              <span className={styles.brandRole}>Visionary Leader</span>
            </div>
          </div>

          <p className={styles.brandBlurb}>
            Visionary leader dedicated to transforming Puducherry into a global
            model of development, innovation, and people-first governance.
          </p>

          <div className={styles.socials}>
            {socials.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                className={styles.social}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>

        {/* ---- Explore ----
            These were <a> elements with an onClick and no href, so they could
            not be reached or activated from the keyboard. Buttons styled as
            links: same look, actually operable. */}
        <nav className={styles.column} aria-label="Explore">
          <h3 className={styles.columnTitle}>Explore</h3>
          <ul>
            {EXPLORE.map((item) => (
              <li key={item.section}>
                <button type="button" onClick={() => handleActive(item.section)}>
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* ---- Latest ---- */}
        <nav className={styles.column} aria-label="More">
          <h3 className={styles.columnTitle}>More</h3>
          <ul>
            {LATEST.map((item) => (
              <li key={item.route}>
                <button type="button" onClick={() => navigate(item.route)}>
                  {item.label}
                </button>
              </li>
            ))}
            <li>
              <a
                href="https://ljkparty.com/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.externalLink}
              >
                LJK Party
                <svg viewBox="0 0 16 16" aria-hidden="true">
                  <path
                    d="M6 3h7v7M13 3L4 12"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </nav>

        {/* ---- Get involved ---- */}
        <div className={styles.column}>
          <h3 className={styles.columnTitle}>Get Involved</h3>
          <p className={styles.involvedText}>
            Join the mission to transform Puducherry.
          </p>
          <button
            type="button"
            className={styles.contactButton}
            onClick={() => navigate("/contact-us")}
          >
            Contact Us
            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path
                d="M3 8h9M8.5 4l4 4-4 4"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* ---- Bottom bar ---- */}
      <div className={styles.bottom}>
        {/* Was a hard-coded 2025, already out of date. */}
        <p className={styles.copyright}>
          © {new Date().getFullYear()} Jose Charles Martin. All rights reserved.
        </p>

        <button type="button" className={styles.toTop} onClick={toTop}>
          <span>Back to top</span>
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path
              d="M8 13V4M4 7.5L8 3.5l4 4"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </footer>
  );
}
